// src/Component/Pages/AdminDashbord/Dashboard.js

import React from "react";
import "./Dashboard.css";

function Dashboard() {
  return (
    <div className="admin d-flex">
      <div className="sidbar">

        <ul className="nav flex-column ">
          <li className="nav-item">
            <a className="nav-link active" href="#">
              <i className="fas fa-tachometer-alt"></i>
              لوحة التحكم <span className="sr-only">(الحالي)</span>
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">
              <i className="fas fa-file"></i>
              التقارير
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">
              <i className="fas fa-cogs"></i>
              الإعدادات
            </a>
          </li>
        </ul>
      </div>
      <div className="contant">
        <header>
          <h3>Welcome To Admin </h3>
        </header>
      </div>
    </div>
  );
}

export default Dashboard;
